import { DropdownButton } from '@anm/components/BuiltInDropdown/Wrapper';
import { DropdownContent } from '@anm/components/Dropdown';
import Image from '@anm/components/image/Image';
import { truncate } from '@anm/styles/helpers';
import styled from 'styled-components';

export const Avatar = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const AvatarMini = styled(Image)`
  position: absolute;
  right: -4px;
  bottom: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
`;

export const AvatarContainer = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  margin-right: 7px;
`;
export const Title = styled.div`
  ${truncate('100px')}
  font-weight: 700;
  font-size: 13px;
  line-height: 20px;
  color: #292a2b;
`;
export const Description = styled.div`
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #71777a;
`;

const Wrapper = styled.div`
  ${DropdownContent} {
    min-width: 100%;
  }
  ${DropdownButton} {
    padding-top: 10px;
  }
`;

export default Wrapper;
